import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React from 'react';

import {
  clearActionLog,
} from '~actions'; // eslint-disable-line

import ActionLogListing from './ActionLogListing';

const propTypes = {
  clearActionLog: PropTypes.func.isRequired,
  actionLog: PropTypes.array,
};

const defaultProps = {
  actionLog: [],
};

const ActionLog = ({ actionLog, clearActionLog: clear }) =>
  <ActionLogListing
    actionLog={actionLog}
    clearActionLog={clear}
  />;

ActionLog.propTypes = propTypes;
ActionLog.defaultProps = defaultProps;

// This adds action creators to components props
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      clearActionLog,
    },
    dispatch,
  );
}

export default connect(null, mapDispatchToProps)(ActionLog);
